export default {
    title: "O-I",
    support: "Steun",
    dashboard: "Dashboard"
}